import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { commanderForm, email, InputField, presence, validation } from '@mews-commander/legacy-form';

export interface EmailSenderFormValues {
    email: string;
}

const constraints = {
    email: {
        presence,
        email,
    },
};

const EmailSenderFormView = () => (
    <InputField
        label={<LocalizedText textKey={TextKey.EmailSenderLabel} />}
        required
        name="email"
        bottomCaption={<LocalizedText textKey={TextKey.EmailSenderExplanation} />}
    />
);

export const EmailSenderForm = commanderForm({
    enableReinitialize: true,
    validate: validation(constraints),
    submitLabel: <LocalizedText textKey={TextKey.Next} />,
    submitButtonProps: { variant: 'primary' },
})(EmailSenderFormView);
